export function isCheckInGateRule(rule) {
    if (rule.targetFieldId !== 'checkInRequired')
        return false;
    return rule.type === 'requiredIf' || (rule.type === 'defaultValueIf' && rule.value === true);
}
//# sourceMappingURL=is-check-in-gate-rule.js.map